<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- full-width START here -->
      <div class="full-width">
        <h3>Happy Customers</h3>
        <p>
          Since the inception of StumptheSpread.com we have valued the opinions
          of our customers. We pride ourselves on going above and beyond when it
          comes to customer service and guarantee we're the best in the industry
          in that department. Below are handicapper reviews, customer comments
          and customer reviews.
        </p>
        <p>Send us your comment to support@stumpthespread.com</p>

        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="6204371474"
          ad-style="display:inline-block;width:728px;height:90px"
          ad-format="auto"
        >
        </adsense>
      </div>
      <!-- full-width END here -->

      <div
        v-for="(test, index) in testimonials"
        :key="test.id"
        class="colum one_half"
      >
        <blockquote>
          <p>
            <span class="dropcap">{{ index + 1 }}</span>
            {{ test.content }}
          </p>
          <div class="sprite testimony-bg"></div>
          <cite>{{ test.author }} &nbsp;<b>{{ test.type }}</b></cite>
        </blockquote>
      </div>
      ';
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import Adsense from "../components/adsense.vue";
import TestimonialRepository from "../data/testimonial.repository";
export default {
  components: {
    adsense: Adsense,
  },
  data() {
    return {
      testimonials: [],
    };
  },
  created() {
    TestimonialRepository.getTestimonials().then((testimonials) => {
      this.testimonials = testimonials;
    });
  },
  metaInfo: {
    title: "Testimonials",
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Testimonials.vue?3783e2ab